import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { interpolateTemplate } from '@/utils/interpolateTemplate';
import { Skeleton, Stack } from '@mui/material';

interface Props {
	label: string;
}

export const HEADER_DROP_MENU_CARD = 'DPSV2HeaderDropMenuCard_{{label}}';

export const NavBarDropMenuCard: React.FC<Props> = ({ label }) => {
	const spotId = interpolateTemplate(HEADER_DROP_MENU_CARD, { label });
	return (
		<ContentRecommendation
			id={spotId}
			properties={{
				emsName: spotId,
			}}
			loadingElement={
				<Stack spacing={1}>
					<Skeleton variant="rounded" width={307} height={200} />
					<Skeleton variant="rounded" width={180} height={'15px'} />
					<Skeleton variant="rounded" width={100} height={'15px'} />
				</Stack>
			}
		/>
	);
};
